import type { AppRouter } from '@rivaled/api/src/router.js';
import { createTRPCReact } from '@trpc/react-query';

export const trpc = createTRPCReact<AppRouter>();
